const colors = {
    primary: "#f7d987",
    secondary: "#0761B1",
    tertiary: "#eb017b",
    dark: "#222",
    gray: "#1F303E",
    grayBlue: "#d9eafc",
};

export default colors;
